import React from 'react';
import { useTranslation } from 'react-i18next';

const GoogleForStartupsBadge = ({ className = '' }) => {
  const { t } = useTranslation();

  return (
    <div className="mt-20">
      <img
          src="/assets/img/google_for_startups.png"
          alt="Google for Startups"
          className="img-fluid"
          style={{ maxWidth: '35%' }}
          title={t('google_for_startups_tooltip')}
          aria-label={t('google_for_startups_tooltip')}
        />
    </div>
  );
};

export default GoogleForStartupsBadge;
